module.exports = __webpack_public_path__ + "img/09.6562b878.jpg";